module.exports = __webpack_public_path__ + "static/media/ImageDesktop.aa35aa1c.svg";